export interface TimelineSettings {
  isRowGroupExpanded(rowGroupName: string): boolean | undefined;
  setRowGroupExpanded(args: { rowGroupName: string; expanded: boolean }): void;
}

export function getTimelineSettings(): TimelineSettings {
  return new TimelineSettingsImpl();
}

type TimelineSettingsData = {
  rowGroupExpandState: any;
};

class TimelineSettingsImpl implements TimelineSettings {
  private data: TimelineSettingsData = {
    rowGroupExpandState: {},
  };

  constructor() {
    const dataStr = localStorage.getItem('timelineSettings');
    if (dataStr) {
      this.data = JSON.parse(dataStr);
    }
  }

  setRowGroupExpanded(args: { rowGroupName: string; expanded: boolean }): void {
    this.data.rowGroupExpandState[args.rowGroupName] = args.expanded;
    this.save();
  }

  isRowGroupExpanded(rowGroupName: string): boolean | undefined {
    return this.data.rowGroupExpandState[rowGroupName];
  }

  save(): void {
    localStorage.setItem('timelineSettings', JSON.stringify(this.data));
  }
}
